import React, { useState } from "react";
import { Button } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import ExcelImage from "images/excelimg.png";
import trashImg from "images/trash.png";
import PdfImage from "images/pdf-svgrepo-com.svg";
import "./style.css";
import SingleSelectSearch from "../Utility/SingleSelectSearch";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteRow,
  downloadExcel,
  getEinvoiceData,
  onDownloadBulkPdf,
  onDownloadReport,
  onGeneratePartB,
  onGetIRN,
  onSubmitInvoice,
  setReceipientGstinFilter,
  setSelected,
  setSelectedGstin,
  setSupplierGstinFilter,
} from "./action";
import DownloadModalPDF from "./Modals/DownloadModalPDF";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";
import swal from "sweetalert";
import {
  customStyles,
  getWhiteData,
  nonInvoiceGenerateData,
  nonGenerateData,
  nonInvoiceCancelledData,
  nonTxnNonsubmitData,
} from "../Utility/Utility";
import DownloadModal from "./Modals/DownloadModal";
import PartBModal from "./Modals/PartBModal";
import PartBErrorModal from "./Modals/PartBErrorModal";
import EinvFilter from "./EinvFilter";
import NewPdfModal from "./Modals/NewPdfModal";

const SubFilterBar = (props) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openPDF, setOpenPDF] = useState(false);
  const [openPartBError, setOpenPartBError] = useState(false);
  const [generateModal, setGenerateModal] = useState(false);
  const [selectedTxn_Id, setSelectedTxn_Id] = useState("");
  const [selectedRowGenerate, setSelectedRowGenerate] = useState([]);
  const [generateTransportDocDate, setGenerateTransportDocDate] = useState("");
  const [transportData, setTransportData] = useState({
    transportDocDate: "",
    transportDistance: "0",
    transportDocNo: "",
    transportId: "",
    transportMode: "",
    transportNo: "",
    vehicleType: "",
    vehicleNo: "",
  });
  const [supplierGstin, setSupplierGstin] = useState(null);
  const [receipientGstin, setReceipientGstin] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [openNewPDF, setOpenNewPDF] = useState(false);
  const {
    selected,
    tableData,
    selectedGstin,
    searchStr,
    checkedCancel,
    checkedIrn,
    checkedIrnNotGen,
    statusCodeCancel,
    statusCode,
    statusCodeNotGen,
    supplierGstinFilter,
    receipientGstinFilter,
    selectedRow,
    buyerGstinList,
    selectedFromDate,
    selectedToDate,
     totalRecords,
  } = useSelector((state) => state.EinvReducerNew);

  const [checkedItems, setCheckedItems] = useState({
    eInv: false,
    ewayBill: false,
  });

  const handleDeleteRecords = (row) => {
    var dataTxn;
    let result = getWhiteData(tableData);
    const checkData = selected?.every((element) => {
      return result.includes(element);
    });
    if (checkedIrn || checkedCancel || !checkData) {
      errorToastMessage(COMMON_MSGS.DELETE_NOT_ALLOWED);
    } else {
      if (selected?.length != 0) {
        // console.log("Multi delete if", selected);
        swalDelete(selected);
      } else if (row != undefined && row != "") {
        // console.log('Else if row',row);
        dataTxn = [row.txn_id];
        // console.log("Multi else if delete", dataTxn);
        swalDelete(dataTxn);
      } else {
        // console.log("Else row", row);
        errorToastMessage(COMMON_MSGS.SELECT_RECORD);
      }
    }
    dispatch(setSelected([]));
  };

  const swalDelete = (dataTxn) => {
    swal({
      title: "Are you sure?",
      text: " Do you want to delete record?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await dispatch(deleteRow(dataTxn));
        // if (checkedCancel) {
        //   await dispatch(
        //     getEinvoiceData(searchStr, "", statusCodeCancel)
        //   );
        // } else {
        //   await dispatch(getEinvoiceData());
        // }
        dispatch(
          getEinvoiceData(
            searchStr,
            props.pageNumber,
            checkedIrn === true
              ? 1
              : checkedCancel === true
              ? 2
              : checkedIrnNotGen === true
              ? 3
              : ""
          )
        );
      }
    });
  };

  const handleDownloadPDFOpen = () => {
    // setOpenPDF(true);
    // if (
    //   selected?.length === 0 ||
    //   (supplierGstinFilter?.length === 0 ||
    //     receipientGstinFilter?.length === 0 ||
    //     !selectedFromDate ||
    //     !selectedToDate)
    // ) {
    //   return errorToastMessage("Please select atleast one record");
    // }
    // const noFiltersSelected =
    //   (!supplierGstinFilter || supplierGstinFilter.length === 0) &&
    //   (!receipientGstinFilter || receipientGstinFilter.length === 0) &&
    //   !selectedFromDate &&
    //   !selectedToDate;

    // if (selected?.length === 0 && noFiltersSelected) {
     if (selected?.length === 0) {
      return errorToastMessage("Please select at least one record");
    }
    const hasError = selectedRow?.some((row) => row.is_error !== 1);
    if (hasError) {
      return errorToastMessage("Please select IRN generated records only");
    }

    // if (
    //   (selected?.length === 0 && tableData?.length > 25) ||
    //   selected?.length > 25
    // ) {
    //   setCheckedItems({
    //     eInv: true,
    //     ewayBill: false,
    //   });
    // }
    setCheckedItems({
      eInv: false,
      ewayBill: false,
    });
    setOpenNewPDF(true);
  };

  const handleDownloadPDF = async (val) => {
    try {
      let fromDate = moment(new Date(val.fromDate)).format("DD/MM/YYYY");
      let toDate = moment(new Date(val.toDate)).format("DD/MM/YYYY");
      await dispatch(onDownloadBulkPdf(fromDate, toDate));
      setOpenPDF(false);
    } catch (err) {
      console.log(`Error in handleDownloadPDF: ${err}`);
    }
  };

  const handleDownloadExcel = () => {
    var status =
      statusCode != ""
        ? statusCode
        : statusCodeCancel != ""
        ? statusCodeCancel
        : statusCodeNotGen != ""
        ? statusCodeNotGen
        : "";

    let result = getWhiteData(tableData);
    const checkData = selected.every((element) => {
      return result.includes(element);
    });
    if (checkedIrn || checkedCancel || !checkData) {
      errorToastMessage(COMMON_MSGS.EXCEL_DOWNLOAD);
    } else {
      dispatch(downloadExcel(selected, status));
    }

    dispatch(setSelected([]));
  };

  const handleGenerateIRN = async (selected) => {
    try {
      // if(selected?.length === 0){
      //   return errorToastMessage(COMMON_MSGS.SELECT_RECORD)
      // }
      let result = nonTxnNonsubmitData(tableData);
      const checkTable = selected.every((element) => {
        return result.includes(element);
      });
      if (checkTable) {
        if (selected?.length != 0) {
          await dispatch(onSubmitInvoice(selected));
          props.fetchEinvoiceData();
        } else {
          errorToastMessage(COMMON_MSGS.SELECT_RECORD);
        }
      } else {
        let invoiceData = nonInvoiceGenerateData(tableData);
        let cancelData = nonInvoiceCancelledData(tableData);
        const checkInvoiceGenerated = selected.every((element) => {
          return invoiceData.includes(element);
        });
        const checkInvoiceCancelled = selected.every((element) => {
          return cancelData.includes(element);
        });

        if (checkInvoiceGenerated) {
          errorToastMessage(COMMON_MSGS.IRN_EXISTS);
        } else if (checkInvoiceCancelled) {
          errorToastMessage(COMMON_MSGS.CANCELLED_INVOICE);
        } else {
          errorToastMessage(COMMON_MSGS.IRN_MSG);
        }
      }
      dispatch(setSelected([]));
    } catch (err) {
      console.log(`Error in handleGenerateIRN: ${err}`);
    }
  };

  // const handleGetIRN = async (selected) => {
  //   try {
  //     const selectedTxn_Id = tableData.filter((element) => {
  //       return element.txn_id == selected[0];
  //     });
  //     const data = {
  //       doc_no: selectedTxn_Id[0]["5|DocDtlsNo|Document_Num"],
  //       doc_date: selectedTxn_Id[0]["6|DocDtlsDt|Document_Date"],
  //       doc_type: selectedTxn_Id[0]["4|DocDtlsTyp|Document_Type_Code"],
  //       seller_gstin: selectedTxn_Id[0]["25|SellerDtlsGstin|Supplier_GSTIN"],
  //       txn_id: selectedTxn_Id[0].txn_id,
  //     };
  //     let result = nonTxnNonsubmitData(tableData);
  //     const checkTable = selected.every((element) => {
  //       return result.includes(element);
  //     });
  //     if (checkTable) {
  //       await dispatch(onGetIRN(data));
  //       props.fetchEinvoiceData();
  //     } else {
  //       let invoiceData = nonInvoiceGenerateData(tableData);
  //       let cancelData = nonInvoiceCancelledData(tableData);
  //       const checkInvoiceGenerated = selected.every((element) => {
  //         return invoiceData.includes(element);
  //       });
  //       const checkInvoiceCancelled = selected.every((element) => {
  //         return cancelData.includes(element);
  //       });
  //       console.log("checkInvoiceGenerated green", checkInvoiceGenerated);
  //       console.log("checkInvoiceCancelled greey", checkInvoiceCancelled);
  //       if (checkInvoiceGenerated) {
  //         errorToastMessage(COMMON_MSGS.IRN_EXISTS);
  //       } else if (checkInvoiceCancelled) {
  //         errorToastMessage(COMMON_MSGS.CANCELLED_INVOICE);
  //       } else {
  //         errorToastMessage(COMMON_MSGS.IRN_MSG);
  //       }
  //     }
  //     dispatch(setSelected([]));
  //   } catch (err) {
  //     console.log(`Error in handleGetIRN: ${err}`);
  //   }
  // };

  // handle get irn new:
  const handleGetIRN = async (selected) => {
    try {
      if (!selected || selected?.length === 0) {
        errorToastMessage("Please select at least one record.");
        return;
      }

      // Check for invalid txn_ids before continuing
      const invalidTxnIds = selected.filter(
        (txn_id) => !tableData.some((item) => item.txn_id === txn_id)
      );

      if (invalidTxnIds?.length > 0) {
        errorToastMessage("Missing or invalid transaction(s)");
        dispatch(setSelected([]));
        return;
      }
      // Step 1: Prepare references
      const eligibleTxns = nonTxnNonsubmitData(tableData); // txn_ids eligible for IRN
      const alreadyInvoicedTxns = nonInvoiceGenerateData(tableData); // txn_ids where invoice already exists
      const cancelledTxns = nonInvoiceCancelledData(tableData); // txn_ids that are cancelled

      // console.log("eligibleTxns::", eligibleTxns);
      // console.log("alreadyInvoicedTxns::", alreadyInvoicedTxns);
      // console.log("cancelledTxns::", cancelledTxns);

      // Step 2: Classify selected txns
      const ineligibleDueToInvoice = [];
      const ineligibleDueToCancellation = [];
      const eligiblePayloads = [];

      selected?.forEach((txn_id) => {
        const txn = tableData?.find((item) => item.txn_id === txn_id);
        if (!txn) return; // Skip if txn not found

        if (alreadyInvoicedTxns?.includes(txn_id)) {
          ineligibleDueToInvoice.push(txn_id);
        } else if (cancelledTxns?.includes(txn_id)) {
          ineligibleDueToCancellation.push(txn_id);
        } else if (eligibleTxns?.includes(txn_id)) {
          // Construct payload
          eligiblePayloads.push({
            doc_no: txn["5|DocDtlsNo|Document_Num"],
            doc_date: txn["6|DocDtlsDt|Document_Date"],
            doc_type: txn["4|DocDtlsTyp|Document_Type_Code"],
            seller_gstin: txn["25|SellerDtlsGstin|Supplier_GSTIN"],
            txn_id: txn.txn_id,
          });
        }
      });

      // console.log("ineligibleDueToInvoice::", ineligibleDueToInvoice);
      // console.log("ineligibleDueToCancellation::", ineligibleDueToCancellation);
      // console.log("eligiblePayloads::", eligiblePayloads);

      // Step 3: Handle validation errors
      if (ineligibleDueToInvoice?.length > 0) {
        errorToastMessage(COMMON_MSGS.IRN_EXISTS);
      }

      if (ineligibleDueToCancellation?.length > 0) {
        errorToastMessage(COMMON_MSGS.CANCELLED_INVOICE);
      }

      // console.log(
      //   "returning since selected?.length !== eligiblePayloads?.length::",
      //   selected?.length !== eligiblePayloads?.length
      // );
      if (selected?.length !== eligiblePayloads?.length) {
        const ineligible = selected?.filter(
          (txn_id) => !eligibleTxns.includes(txn_id)
        );
        if (
          ineligible?.length > 0 &&
          ineligibleDueToInvoice?.length === 0 &&
          ineligibleDueToCancellation?.length === 0
        ) {
          errorToastMessage(COMMON_MSGS.IRN_MSG);
        }
        dispatch(setSelected([]));
        return;
      }

      // Step 4: All are valid, call dispatch for IRN generation

      // console.log("API call success with payload::", eligiblePayloads);
      await dispatch(onGetIRN(eligiblePayloads));
      props.fetchEinvoiceData();
      dispatch(setSelected([]));
    } catch (err) {
      console.log(`Error in handleGetIRN: ${err}`);
    }
  };

  //   | Test Scenario                            | Expected Outcome                    |
  // |-----------------------------------------|-------------------------------------|
  // | No rows selected                        | Show a "select a transaction" toast |
  // | One row selected, already invoiced      | Show IRN_EXISTS error               |
  // | Multiple selected, some cancelled       | Show CANCELLED_INVOICE error        |
  // | Invalid `txn_id` in `selected`          | Show "Transaction not found" error  |
  // | Missing keys in payload fields          | Show IRN_MSG generic error          |
  // | Duplicate `txn_id`s in `selected`       | Ignore duplicates, no crash         |
  // | API fails during IRN generation         | Show "Generation Failed" toast      |

  const handleGeneratePartB = async (selected) => {
    try {
      let result = nonGenerateData(tableData);
      const containsAll = result?.filter((element) => {
        return element == selected[0];
      });
      const containsAll1 = tableData?.filter((element) => {
        return element.txn_id == selected[0];
      });
      let enbNo = "";
      let date = "";
      var newDate = "";
      if (containsAll?.length > 0) {
        const ewayBillGenrateOrNot = tableData?.filter((element) => {
          return element.txn_id == selected[0];
        });

        for (var key of ewayBillGenrateOrNot) {
          enbNo = key["0|EwbNo|EwbNo"];
          date = key["70|EwbDtlsTransDocDt|Trans_Doc_Date"];
        }
        if (enbNo) {
          errorToastMessage(COMMON_MSGS.PARTB_EXISTS);
        } else {
          if (date) {
            date = date?.split("/");
            newDate = `${date[2]}-${date[1]}-${date[0]}`;
          }

          setSelectedTxn_Id(selected[0]);
          setSelectedRowGenerate(containsAll1);

          if (!containsAll1 || containsAll1?.length === 0) return;

          // Extracting the first item (assuming only one is needed)
          const key = containsAll1[0];

          setTransportData({
            transportDocDate: key["70|EwbDtlsTransDocDt|Trans_Doc_Date"] || "",
            transportDistance: key["67|EwbDtlsDistance|Trans_Distance"] || "0",
            transportDocNo: key["69|EwbDtlsTransDocNo|Trans_Doc_No"] || "",
            transportId: key["65|EwbDtlsTransId|Transporter_ID"] || "",
            transportMode: key["66|EwbDtlsTransMode|Trans_Mode"] || "",
            transportNo: key["68|EwbDtlsTransName|Transporter_Name"] || "",
            vehicleType: key["72|EwbDtlsVehType|Vehicle_Type"] || "",
            vehicleNo: key["71|EwbDtlsVehNo|Vehicle_No"] || "",
          });

          setGenerateTransportDocDate(date ? newDate : "");
          setGenerateModal(true);
        }
      } else {
        errorToastMessage(COMMON_MSGS.GENERATION_OF_PARTB);
      }
    } catch (err) {
      console.log(`Error in handleGeneratePartB: ${err}`);
    }
  };

  const handleDownloadOpen = () => {
    setOpen(true);
  };

  const handleDownloadReport = async (values) => {
    try {
      await dispatch(onDownloadReport(values));
      setOpen(false);
    } catch (err) {
      console.log(`Error in handleDownloadReport: ${err}`);
    }
  };

  const handleSubmit = () => {
    dispatch(
      getEinvoiceData(
        searchStr,
        props.pageNumber,
        checkedIrn === true
          ? 1
          : checkedCancel === true
          ? 2
          : checkedIrnNotGen === true
          ? 3
          : "",
        selectedGstin
      )
    );
  };

  const handleFilter = () => {
    // console.log("handleFilter");
    setOpenFilter(true);
  };

  const icons = [
    {
      src: trashImg,
      alt: "Delete Records",
      title: "Delete Records",
      className: "icon",
      onClick: () => handleDeleteRecords(),
    },
    {
      src: PdfImage,
      alt: "Download PDF",
      title: "Download PDF",
      className: "icon pdf-icon",
      onClick: handleDownloadPDFOpen,
    },
    {
      src: ExcelImage,
      alt: "Download Excel",
      title: "Download Excel",
      className: "icon excel-icon",
      onClick: handleDownloadExcel,
    },
  ];

  const buttons = [
    // {
    //   label: "Submit",
    //   bgColor: "#4f2d7f",
    //   onClick: handleSubmit,
    // },
    {
      label: "Generate IRN",
      onClick: () => handleGenerateIRN(selected),
      bgColor: "#4f2d7f",
      disabled: selected?.length === 0,
      title: selected?.length === 0 ? COMMON_MSGS.SELECT_RECORD : ''
    },
    {
      label: "Generate Part B",
      onClick: () => handleGeneratePartB(selected),
      bgColor: "#4f2d7f",
      disabled: selected?.length !== 1,
      title: selected?.length !== 1 ? 'Please select a record' : ''
    },
    {
      label: "Get IRN",
      onClick: () => handleGetIRN(selected),
      disabled: selected?.length === 0,
      bgColor: "#4f2d7f",
      title: selected?.length === 0 ? COMMON_MSGS.SELECT_RECORD : ''
    },
    {
      label: "Download Report",
      onClick: handleDownloadOpen,
      bgColor: "#4f2d7f",
    },
    {
      label: "Filter",
      bgColor: "#4f2d7f",
      onClick: handleFilter,
    },
  ];

  const onSubmitForm = async (val) => {
    try {
      const data = {
        transportDocDate: generateTransportDocDate,
        txn_id: selectedTxn_Id,
        transportDistance: val?.transportDistance,
        transportDocNo: val?.transportDocNumber,
        transportId: val?.transporterId,
        transportMode: val?.transportMode,
        transportNo: val?.transporterName,
        vehicleType: val?.vehicleType,
        vehicleNo: val?.vehicleNo,
      };
      const response = await dispatch(onGeneratePartB(data));
      dispatch(
        getEinvoiceData(
          searchStr,
          1,
          checkedIrn === true
            ? 1
            : checkedCancel === true
            ? 2
            : checkedIrnNotGen === true
            ? 3
            : ""
        )
      );
      setGenerateModal(false);
      dispatch(setSelected([]));
      if (response === 1) setOpenPartBError(true);
      else setOpenPartBError(false);
    } catch (err) {
      console.log(`Error in onSubmitForm: ${err}`);
    }
  };

  async function handleOptionChange(option) {
    try {
      if (option) {
        dispatch(setSelectedGstin(option.value));
      } else {
        dispatch(setSelectedGstin(""));
      }
    } catch (err) {
      console.log("Error in handleOptionChange: ", err);
    }
  }

  function handleChipDelete(index, type) {
    let temp;
    if (type === "gstin") {
      temp = [...supplierGstinFilter];
      temp.splice(index, 1);
      dispatch(setSupplierGstinFilter(temp));
    } else if (type === "rgstin") {
      temp = [...receipientGstinFilter];
      temp.splice(index, 1);
      dispatch(setReceipientGstinFilter(temp));
    } else console.log("error in handleChipDelete");
  }

  const defaultPropsSupplierGstins = {
    options: props.gstinList,
    getOptionLabel: (option) => option,
  };

  const defaultPropsReceipientGstins = {
    options: buyerGstinList,
    getOptionLabel: (option) => option,
  };

  function onChangeSupplierGstin(newValue) {
    setSupplierGstin(newValue);
  }

  function onChangeReceipientGstin(newValue) {
    setReceipientGstin(newValue);
  }

  function handleAddSupplierGstin() {
    if (supplierGstin != null) {
      let temp = [...supplierGstinFilter, supplierGstin];
      temp = [...new Set([...temp])];
      dispatch(setSupplierGstinFilter(temp));
      setSupplierGstin(null);
    }
  }

  function handleAddReceipientGstin() {
    if (receipientGstin != null) {
      let temp = [...receipientGstinFilter, receipientGstin];
      temp = [...new Set([...temp])];
      dispatch(setReceipientGstinFilter(temp));
      setReceipientGstin(null);
    }
  }

  return (
    <>
      <div className="button-group">
        {/*  <div style={{ position: "relative", zIndex: "2" }}>
          <SingleSelectSearch
            options={props.profileList}
            customStyles={customStyles}
            handleOptionChange={handleOptionChange}
          />
        </div> */}

        {/* {buttons.map((button, index) => (
          //  <Tooltip key={index} title={button?.title} placement="bottom">
          <Button
            key={index}
            variant="contained"
            color="primary"
            className={
              button.label !== "Generate IRN"
                ? "action-button"
                : "generate-button"
            }
            onClick={button.disabled ? null : button.onClick}
            style={{
              backgroundColor: button.disabled ? "gray" : button.bgColor,
              color: "white",
              cursor: button.disabled ? "not-allowed" : "pointer",
            }}
          >
            {button.label}
          </Button>
           return button.title ? (
    <Tooltip key={index} title={button.title} placement="bottom">
      <span>{buttonElement}</span>
    </Tooltip>
  ) : (
    <span key={index}>{buttonElement}</span>
  );
          // </Tooltip>
        ))} */}
        {buttons.map((button, index) => {
  const buttonElement = (
    <Button
      key={index}
      variant="contained"
      color="primary"
      className={
        button.label !== "Generate IRN"
          ? "action-button"
          : "generate-button"
      }
      onClick={button.disabled ? null : button.onClick}
      style={{
        backgroundColor: button.disabled ? "gray" : button.bgColor,
        color: "white",
        cursor: button.disabled ? "not-allowed" : "pointer",
      }}
    >
      {button.label}
    </Button>
  );

  // Conditionally wrap in Tooltip only when title exists
  return button.title ? (
    <Tooltip key={index} title={button.title} placement="bottom">
      <span>{buttonElement}</span>
    </Tooltip>
  ) : (
    <span key={index}>{buttonElement}</span>
  );
})}


        {icons.map((icon, index) => (
          <Tooltip key={index} title={icon.title} placement="bottom">
            <img
              src={icon.src}
              alt={icon.alt}
              className={icon.className}
              onClick={icon.onClick}
            />
          </Tooltip>
        ))}
        <div
            style={{
              paddingTop: "1em",
              paddingBottom: "1em",
              marginLeft: "1em",
            }}
          >
            <span
              style={{
                fontFamily: "Gt-Walsheim-medium",
              }}
            >
              Total Records:{" "}
              <span
                style={{
                  display: "inline",
                  fontSize: "16px",
                  fontFamily: "Gt-Walsheim-medium",
                }}
              >
                {totalRecords}
              </span>
            </span>
            <br />
          </div>
      </div>
      <DownloadModal
        onDownloadReport={handleDownloadReport}
        open={open}
        setOpen={setOpen}
      />

      {/* commenting this modal as per new req GG 7903 */}
      {/* <DownloadModalPDF
        onDownloadReport={handleDownloadPDF}
        open={openPDF}
        setOpen={setOpenPDF}
      /> */}

      <PartBModal
        setGenerateModal={setGenerateModal}
        generateModal={generateModal}
        onSubmitForm={onSubmitForm}
        generateTransportDocDate={generateTransportDocDate}
        selectedRowGenerate={selectedRowGenerate}
        transportData={transportData}
      />

      <PartBErrorModal open={openPartBError} setOpen={setOpenPartBError} />

      <EinvFilter
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        supplierGstin={supplierGstin}
        handleChipDelete={handleChipDelete}
        defaultPropsSupplierGstins={defaultPropsSupplierGstins}
        onChangeSupplierGstin={onChangeSupplierGstin}
        handleAddSupplierGstin={handleAddSupplierGstin}
        defaultPropsReceipientGstins={defaultPropsReceipientGstins}
        receipientGstin={receipientGstin}
        onChangeReceipientGstin={onChangeReceipientGstin}
        handleAddReceipientGstin={handleAddReceipientGstin}
        pageNumber={props.pageNumber}
        setPageNumber={props.setPageNumber}
      />

      <NewPdfModal
        openNewPDF={openNewPDF}
        setOpenNewPDF={setOpenNewPDF}
        checkedItems={checkedItems}
        setCheckedItems={setCheckedItems}
      />
    </>
  );
};

export default SubFilterBar;
